import React, { useCallback, useEffect, useRef, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast, ToastContainer } from 'react-toastify';
import axiosInsatnace, { chatStatus, contactView, GetMatchesBYType, getProfileById, profileActivity } from '../../asiosConfig';
import '../UserComponent/MatchProfileContainer.css';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import profileImage from "../../images/no-photo.png";
import { Box, Button, ButtonBase, Chip, CircularProgress, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Skeleton, Typography, useMediaQuery } from '@mui/material';
import { AddCircleSharp, Call, Chat, Check, Close, NotificationsActive, RemoveCircleSharp, Send, Star } from '@mui/icons-material';
import debounce from 'lodash.debounce'; // Make sure to install lodash.debounce
import femaleImg from "../../images/femaleMatch.png";
import maleImg from "../../images/maleMatch.png";
import goldIcon from "../../images/gold.png";
import platinumIcon from "../../images/platinum.png";
import diamondIcon from "../../images/diamond.png";
import premiumPlusIcon from "../../images/premiumPlus.png";
import tillUMarryIcon from "../../images/marry.png";
import { CircularLoader } from '../CircularLoader';
import educIcon from "../../images/educIcon.png";
import jobIcon from "../../images/jobIcon.png";
import heightIcon from "../../images/heightIcon.png";
import Profileicon from "../../images/ProfileInfoIcon.png";
import popup from "../../images/popup_design.png";
import TimeDateIcon from "../../images/TimeDateIcon.png";
import shortlistIcon from "../../images/shortlistIcon.png";
import SendInterest from "../../images/SendInterest.png";
import IgnoreIcon from "../../images/IgnoreIcon.png";
import ContactIcon from "../../images/ContactIcon.png";
import AcceptInterestIcon from "../../images/AcceptInterestIcon.png";
import BookMarkRemoveIcon from "../../images/BookmarkIcon.png";
import DeclinedInterestIcon from "../../images/DelinedIcon.png";
import sendRemidIcon from "../../images/SendReminderIcon.png";
import ChatIcon from "../../images/ChatIcon.png";
import RemoveIgnoreIcon from "../../images/RemoveIgnoreIcon.png";
import { useTheme } from "@mui/material/styles";
import { handleStartChat } from './handleStartChat';
import { collection } from 'firebase/firestore';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../services/firebaseConfig';
import MessengerModal from '../MessengerModel';


const formatTitle = (title) => {
    return title
        .replace(/_/g, ' ') // Replace underscores with spaces
        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
};

const packageIcons = {
    Gold: goldIcon,
    Platinum: platinumIcon,
    Diamond: diamondIcon,
    Premium: premiumPlusIcon,
    "Premium +": premiumPlusIcon,
    "Till U Marry": tillUMarryIcon,
};
function MatchProfileContainer({ filters }) {
    const { matchesType: paramMatchesType } = useParams();
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [contactInfo, setContactInfo] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [dataLoaded, setDataLoaded] = useState(false);
    const navigate = useNavigate();
    const observer = useRef();
    const matchesType = paramMatchesType || 'my_matches';
    const title = paramMatchesType ? formatTitle(paramMatchesType) : 'My Matches';
    // const token = localStorage.getItem('token');
    const gender = localStorage.getItem('gender');
    const [openReminderPopup, setOpenReminderPopup] = useState(false);
    const [reminderData, setReminderData] = useState(null);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const username = localStorage.getItem('username');

    const [openMessengerModal, setOpenMessengerModal] = useState(false);


    // Debounce function to limit API calls
    const fetchMatches = useCallback(
        async (currentPage, currentFilters, currentMatchType) => {
            setLoading(true);
            try {
                const response = await GetMatchesBYType({
                    matches_type: currentMatchType,
                    page: currentPage,
                    filters: currentFilters
                });
                if (response.status === 200 || response.status === 201) {
                    const newMatches = response.data.result;
                    setMatches(prevMatches => [...prevMatches, ...newMatches]);
                    setHasMore(newMatches.length > 0);
                }
            } catch (error) {
                toast.error("Something went wrong");
            } finally {
                setLoading(false);
                setDataLoaded(true);
            }
        },
        []
    );

    // Debounced version of fetchMatches
    const debouncedFetchMatches = useCallback(
        debounce((page, filters, matchType) => {
            fetchMatches(page, filters, matchType);
        }, 500),
        [fetchMatches]
    );

    // Trigger fetch when matchesType or filters change
    useEffect(() => {
        // Reset state when matchesType changes
        setMatches([]);
        setPage(1);
        setHasMore(true);
        setDataLoaded(false);
        debouncedFetchMatches(1, filters, matchesType);
    }, [matchesType, filters, debouncedFetchMatches]);

    // Handle page changes for infinite scrolling
    useEffect(() => {
        if (!loading && hasMore && page > 1) {
            debouncedFetchMatches(page, filters, matchesType);
        }
    }, [page, filters, matchesType, debouncedFetchMatches]);

    const lastMatchElementRef = useRef();

    useEffect(() => {
        if (loading || !hasMore) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                setPage(prevPage => prevPage + 1);
            }
        });
        if (lastMatchElementRef.current) {
            observer.current.observe(lastMatchElementRef.current);
        }
    }, [loading, hasMore]);

    const defaultImage = gender === 'F' ? maleImg : femaleImg;

    const handleSearch = (profileId) => {
        logEvent(analytics, "view_profile", {
            viewed_profile_id: profileId,
            profile_viewer_id: localStorage.getItem('user'),
            timestamp: new Date().toISOString(),
        });
        // Navigate to the profile view with the user_id
        navigate('/profile-view', { state: { user_id: profileId } });
    };

    const handleAction = async (url, data, label) => {
        setLoading(label); // Set loading state to the current action label
        try {
            const response = await axiosInsatnace.post(url, data); // Make API call
            const { status, message } = response.data;

            if (status === 5 && message === "Interest already sent to this user") {
                // Trigger popup when interest is already sent
                const updateData = { ...data, response_type: 'send_reminder' }

                setReminderData({ url, data: updateData });
                setOpenReminderPopup(true);
            } else if (response.status === 200 || response.status === 201) {
                // Handle successful responses
                logEvent(analytics, 'user_action', {
                    user_id: localStorage.getItem('user'),
                    profile_id: data.user_id,
                    action: data.response_type,
                    platform: 'web',
                    timestamp: new Date().toISOString(),
                })
                toast.success(message);
            } else {
                // Handle other statuses
                toast.error(message);
            }
        } catch (error) {
            // Improved error handling with a fallback message
            const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
            toast.error(errorMessage);
        } finally {
            setLoading(null); // Reset loading state after the response
        }
    };

    const handleReminder = async (url, data, label) => {
        // set loading state to the current action label
        try {
            const response = await axiosInsatnace.post(url, data);
            if (response.status === 200 || response.status === 201) {
                logEvent(analytics, 'sendReminder', {
                    user_id: localStorage.getItem('user'),
                    profile_id: data.user_id,
                    action: data.response_type,
                    platform: 'web',
                    timestamp: new Date().toISOString(),
                })
                toast.success(response.data.message);

            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message);
        } finally {
            setLoading(null); // reset loading state after response
        }
    };
    const handleSendReminder = async () => {
        if (!reminderData) return;
        setLoading("Send Reminder");
        try {
            const response = await axiosInsatnace.post(reminderData.url, reminderData.data);
            if (response.status === 200 || response.status === 201) {
                toast.success(response.data.message);
                setOpenReminderPopup(false); // Close the popup after success
            } else {
                setOpenReminderPopup(false);
                toast.error(response.data.message);
            }
        } catch (error) {
            setOpenReminderPopup(false);
            toast.error(error.response?.data?.message || "Failed to send reminder");
        } finally {
            setLoading(null);
        }
    };
    const handleContactClick = async (recipientId) => {
        setLoading("Contact");
        try {
            const response = await contactView({ profile_id: recipientId });
            if (response.status === 200 || response.status === 201) {
                logEvent(analytics, 'view_contact', {
                    user_id: localStorage.getItem('user'),
                    profile_id: recipientId,
                    action: 'contact_view',
                    platform: 'web',
                    timestamp: new Date().toISOString(),
                });

                setContactInfo(response.data.data);
                setOpenModal(true);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to retrieve contact info');
        } finally {
            setLoading(null);
        }
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const startChat = async (recipientId, profile) => {
        // const currentUserId = username;
        // const chatId = [currentUserId, recipientId].sort().join('_');
        // try {
        //     const response = await chatStatus({ profile_id: profile.id });

        //     const { SUCCESS, ERROR, chatReason, chatAllowed } = response.data;
        //     if (SUCCESS === 1 && chatAllowed === "true") {
        //         // navigate(`/chat`, { state: { chatId, recipientId, profile } });


        //     } else {
        //         toast.error(ERROR || chatReason);
        //     }
        // } catch (error) {
        //     toast.error("Error starting chat:", error);
        // }
        setOpenMessengerModal(true);


    };
    const getActionButton = (profile) => {

        const { send, received, ignored, bookmarked } = profile;
        if (ignored) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    {/* <Button startIcon={<Chat />} variant="text" className='actionTxt'>Chat</Button> */}
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { user_id: ignored.member_id, response_type: 'remove_ignore' })} >
                        <img src={RemoveIgnoreIcon} alt="Remove Ignore" className="action-icon" />
                        <Typography variant="body2">Remove Ignore</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Star />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', {  user_id: profile.id, response_type: 'bookmark' })}>Shortlist</Button> */}
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)} >
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (bookmarked && !send && !received) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { user_id: profile.id, response_type: 'interest' })} >
                        <img src={SendInterest} alt="Send Interest" className="action-icon" />
                        <Typography variant="body2">Send Interest</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { user_id: profile.id, response_type: 'remove_bookmark' })} >
                        <img src={BookMarkRemoveIcon} alt="Remove Bookmark" className="action-icon" />
                        <Typography variant="body2">Remove Bookmark</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)} >
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', {  user_id: send.recipient, response_type: 'reject' })}>Cancel Interest</Button> */}
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (bookmarked && send && send.accept === 0 && send.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { user_id: profile.id, response_type: 'remove_bookmark' })} >
                        <img src={BookMarkRemoveIcon} alt="Remove Bookmark" className="action-icon" />
                        <Typography variant="body2">Remove Bookmark</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => handleReminder('profile-activity', { user_id: profile.id, response_type: 'send_reminder' })}>
                        <img src={sendRemidIcon} alt="Send Reminder" className="action-icon" />
                        <Typography variant="body2">Send Reminder</Typography>
                    </ButtonBase>

                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)}>
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', {  user_id: send.recipient, response_type: 'reject' })}>Cancel Interest</Button> */}
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (bookmarked && send && send.accept === 1 && send.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { user_id: profile.id, response_type: 'remove_bookmark' })} >
                        <img src={BookMarkRemoveIcon} alt="Remove Bookmark" className="action-icon" />
                        <Typography variant="body2">Remove Bookmark</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)}>
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<RemoveCircleSharp />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', {  user_id: send.recipient, response_type: 'ignored' })}>Ignore</Button> */}
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (bookmarked && received && received.accept === 0 && received.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { user_id: profile.id, response_type: 'remove_bookmark' })} >
                        <img src={BookMarkRemoveIcon} alt="Remove Bookmark" className="action-icon" />
                        <Typography variant="body2">Remove Bookmark</Typography>
                    </ButtonBase>
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { user_id: received.sender, response_type: 'accept' })}>
                        <img src={AcceptInterestIcon} alt="Accept Interest" className="action-icon" />
                        <Typography variant="body2">Accept Interest</Typography>
                    </ButtonBase>
                    <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { user_id: received.sender, response_type: 'reject' })}>Decline Interest</Button>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (bookmarked && received && received.accept === 1 && received.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    {/* <Button startIcon={<Chat />} variant="text" className='actionTxt'>Chat</Button> */}
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { user_id: profile.id, response_type: 'remove_bookmark' })} >
                        <img src={BookMarkRemoveIcon} alt="Remove Bookmark" className="action-icon" />
                        <Typography variant="body2">Remove Bookmark</Typography>
                    </ButtonBase>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', {  user_id: received.sender, response_type: 'reject' })}>Decline Interest</Button> */}
                </Box>
            );
        } else if (!bookmarked && send && send.accept === 0 && send.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => handleReminder('profile-activity', { user_id: profile.id, response_type: 'send_reminder' })}>
                        <img src={sendRemidIcon} alt="Send Reminder" className="action-icon" />
                        <Typography variant="body2">Send Reminder</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)}>
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', {  user_id: send.recipient, response_type: 'reject' })}>Cancel Interest</Button> */}
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (!bookmarked && send && send.accept === 1 && send.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)}>
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<RemoveCircleSharp />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', {  user_id: send.recipient, response_type: 'ignored' })}>Ignore</Button> */}
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>

                </Box>
            );
        } else if (!bookmarked && send && send.accept === 0 && send.reject === 1) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)}>
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    <Button startIcon={<RemoveCircleSharp />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { user_id: send.recipient, response_type: 'ignored' })}>Ignore</Button>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (!bookmarked && received && received.accept === 0 && received.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { user_id: received.sender, response_type: 'accept' })}>
                        <img src={AcceptInterestIcon} alt="Accept Interest" className="action-icon" />
                        <Typography variant="body2">Accept Interest</Typography>
                    </ButtonBase>
                    <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { user_id: received.sender, response_type: 'reject' })}>Decline Interest</Button>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (!bookmarked && received && received.accept === 1 && received.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    {/* <Button startIcon={<Chat />} variant="text" className='actionTxt'>Chat</Button> */}
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { user_id: received.sender, response_type: 'ignored' })}>
                        <img src={IgnoreIcon} alt="Ignore" className="action-icon" />
                        <Typography variant="body2">Ignore</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)}>
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', {  user_id: received.sender, response_type: 'reject' })}>Decline Interest</Button> */}
                </Box>
            );
        } else if (!bookmarked && (send && send?.accept === 1) || !bookmarked && (received && received?.accept === 1)) {

            <Box display="flex" className="action-container" justifyContent="space-between">
                {/* <Button startIcon={<Chat />} variant="text" className='actionTxt'>Chat</Button> */}
                <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { user_id: send.recipient, response_type: 'ignored' })}>
                    <img src={IgnoreIcon} alt="Ignore" className="action-icon" />
                    <Typography variant="body2">Ignore</Typography>
                </ButtonBase>
                <ButtonBase
                    className="action-item"
                    onClick={() => handleContactClick(profile.id)}
                >
                    <img src={ContactIcon} alt="Contact" className="action-icon" />
                    <Typography variant="body2">Contact</Typography>
                </ButtonBase>
                <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { user_id: send.recipient, response_type: 'reject' })}>
                    <img src={DeclinedInterestIcon} alt="Decline Interest" className="action-icon" />
                    <Typography variant="body2">Decline Interest</Typography>
                </ButtonBase>
            </Box>

        } else if (!bookmarked && received && received.reject === 1) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { user_id: received.sender, response_type: 'accept' })}>
                        <img src={AcceptInterestIcon} alt="Accept Interest" className="action-icon" />
                        <Typography variant="body2">Accept Interest</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { user_id: received.sender, response_type: 'ignored' })}>
                        <img src={IgnoreIcon} alt="Ignore" className="action-icon" />
                        <Typography variant="body2">Ignore</Typography>
                    </ButtonBase>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>

                </Box>
            )
        } else {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { user_id: profile.id, response_type: 'interest' })}>
                        <img src={SendInterest} alt="Send Interest" className="action-icon" />
                        <Typography variant="body2">Send Interest</Typography>
                    </ButtonBase>
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { user_id: profile.id, response_type: 'bookmark' })}>
                        <img src={shortlistIcon} alt="Shortlist" className="action-icon" />
                        <Typography variant="body2">Shortlist</Typography>
                    </ButtonBase>
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { user_id: profile.id, response_type: 'ignored' })}>
                        <img src={IgnoreIcon} alt="Ignore" className="action-icon" />
                        <Typography variant="body2">Ignore</Typography>
                    </ButtonBase>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>

            );
        }
    }
    const handleClosePopup = () => {
        setOpenReminderPopup(false);
        setReminderData(null);
    };
    const renderSkeletons = () => {
        return Array.from(new Array(5)).map((_, index) => (
            <div className="girlBG mt-3" key={index}>
                <div className="row">
                    <div className="col-md-4">
                        <Skeleton variant="rectangular" width="100%" height={150} />
                    </div>
                    <div className="col-md-8">
                        <Skeleton variant="text" width="80%" height={30} style={{ marginTop: 10 }} />
                        <Skeleton variant="text" width="60%" />
                        <Skeleton variant="text" width="80%" />
                        <Skeleton variant="text" width="60%" />
                        <Skeleton variant="text" width="40%" />
                        <Skeleton variant="text" width="30%" />
                    </div>
                </div>
            </div>
        ));
    };

    return (
        <div className="col-lg-9 col-12">
            <div className="profileBlock">
                <div className="profieTitle d-flex justify-content-between align-items-center">
                    <h3>{title === 'Who Looking For Me'
                        ? 'Looking For Me'
                        : title === 'Premium'
                            ? 'Premium Matches'
                            : title || 'ALL PROFILE'}</h3>
                    <p className="filtterImg">
                        <a href="/filter">
                            {/* <img src="images/filtterIcon.png" className="img-fluid" alt="filtter img" /> */}
                        </a>
                    </p>
                </div>
            </div>
            {dataLoaded && matches.length === 0 ? (
                <p>No Data Available</p>
            ) : (
                matches.map((item, index) => (
                    <div key={index} ref={index === matches.length - 1 ? lastMatchElementRef : null}>
                        <div className="girlBG mt-3">
                            <div className="row">
                                <div className="col-md-4" onClick={() => handleSearch(item.username)}>
                                    <div className="girlPic h-100">
                                        <img src={item && item.photo ? item.photo : defaultImage} className="img-fluid" alt="profile image" />
                                    </div>
                                </div>
                                <div className="col-md-8 position-relative">
                                    {item.membership_type && item.membership_type !== 'Free' && (
                                        <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }}>
                                            <Chip
                                                icon={
                                                    <img
                                                        src={packageIcons[item.membership_type]}
                                                        alt={`${item.membership_type} icon`}
                                                        style={{ width: '20px', height: '20px' }}
                                                    />
                                                }
                                                label={item.membership_type}
                                                variant="outlined"
                                                sx={{
                                                    textTransform: 'uppercase',
                                                    fontWeight: 'bold',
                                                    fontSize: '0.85rem',
                                                    padding: '5px 10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    backgroundColor: '#ffa779',
                                                    marginTop: isSmallScreen ? 1 : 0,
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className="girlsDetail float-start text-left" onClick={() => handleSearch(item.username)} style={{ cursor: 'pointer' }}>
                                        <p>
                                            <img src={TimeDateIcon} width='24px' /> {item.last_login || "N/A"}
                                        </p>
                                        <p>
                                            <img src={Profileicon} width='24px' /> {item.name} {item.last_name ? ` ${item.last_name}` : ""}, {item.city || ''}, {item.caste || ''}
                                        </p>
                                        <p>
                                            <img src={heightIcon} width='24px' />
                                            {item.age ? item.age + " yr , " : ""}
                                            {item.height ? item.height + " , " : ""}
                                            {item.maritalStatus ? item.maritalStatus : ""}
                                            {/* {item.caste || "N/A"} */}
                                        </p>
                                        <p>
                                            <img src={jobIcon} width='24px' />
                                            {item.occupation || ""},
                                            {item.income ? ` ${item.income} P.A, ` : ""}
                                            {item.residingCity ? item.residingCity : ""}
                                        </p>
                                        <p>
                                            <img src={educIcon} width='24px' />
                                            {item.education || ""}
                                            {item.status ? ` - ${item.status}` : ""}
                                        </p>
                                    </div>
                                    <div className="clearfix"></div>
                                    {getActionButton(item)}
                                </div>
                            </div>
                        </div>
                        <Dialog
                            open={openModal}
                            onClose={handleCloseModal}
                            aria-labelledby="contact-dialog-title"
                            maxWidth="sm"
                            fullWidth
                            sx={{
                                '& .MuiPaper-root': {
                                    width: '500px',
                                    height: '400px',
                                    padding: 4,
                                    backgroundImage: `url('${popup}')`, // Replace with your image URL
                                    backgroundSize: 'cover', // Ensures the image covers the entire background
                                    backgroundRepeat: 'no-repeat', // Prevents tiling
                                    backgroundPosition: 'center', // Centers the image
                                },
                            }}
                        >
                            <DialogTitle id="contact-dialog-title" align="center">
                                <Typography variant="h5">
                                    {contactInfo?.text || ''}
                                </Typography>
                                <Divider variant="middle" sx={{ mb: 2 }} />
                                <IconButton
                                    aria-label="close"
                                    onClick={handleCloseModal}
                                    sx={{
                                        position: 'absolute',
                                        right: 8,
                                        top: 8,
                                        color: (theme) => theme.palette.grey[500],
                                    }}
                                >
                                    <Close />
                                </IconButton>
                            </DialogTitle>
                            <DialogContent>
                                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                                    <div className="viewCall">
                                        {contactInfo ? (
                                            <>
                                                <img src={contactInfo && contactInfo.photo ? contactInfo.photo : defaultImage} style={{ width: '60px', height: '60px', borderRadius: '50%' }} alt="Profile" />
                                                <p className="mt-2">{contactInfo?.username}</p>

                                                <Typography variant="body1">Email: {contactInfo.email}</Typography>
                                                <Typography variant="body1">Phone: {contactInfo.mobileNumber}</Typography>
                                            </>
                                        ) : (
                                            <Typography variant="body2">Loading...</Typography>
                                        )}
                                    </div>
                                </Box>
                            </DialogContent>
                            <div className="d-grid p-3">
                                <a href="/upgrade" target="_blank" className="btn btn-danger vplan">View Plan</a>
                            </div>
                        </Dialog>
                    </div>
                ))
            )}
            {loading && renderSkeletons()}
            {loading && <CircularProgress />}
            <ToastContainer />

            {/* Reminder popup */}
            <Dialog
                open={openReminderPopup}
                onClose={handleClosePopup}
                aria-labelledby="reminder-dialog-title"
                maxWidth="xs"
                fullWidth
                sx={{
                    '& .MuiPaper-root': {
                        backgroundImage: `url('${popup}')`, // Replace with your image URL
                        backgroundSize: 'cover', // Ensures the image covers the entire background
                        backgroundRepeat: 'no-repeat', // Prevents tiling
                        backgroundPosition: 'center', // Centers the image
                    },
                }}
            >
                <DialogTitle id="reminder-dialog-title" align="center">
                    <Typography variant="h6">Interest Already Sent</Typography>
                    <Divider variant="middle" sx={{ mb: 2 }} />
                    <IconButton
                        aria-label="close"
                        onClick={handleClosePopup}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" >
                        <Typography variant="body1" gutterBottom>
                            You have already sent an interest to this user. Would you like to send a reminder?
                        </Typography>
                        <Button
                            variant="contained"
                            sx={{
                                mt: 3,
                                background: "linear-gradient(90deg, #B60202 0%, #500101 100%)",
                                color: "white",
                                borderRadius: 3,
                                padding: "10px 20px",

                            }}
                            disabled={loading === "Send Reminder"}
                            onClick={handleSendReminder}
                        >
                            {loading === "Send Reminder" ? "Sending..." : "Send Reminder"}
                            {/* <Star sx={{ ml: 1, color: "white", fontSize: "20px" }} /> */}
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
            <MessengerModal
                open={openMessengerModal}
                onClose={() => setOpenMessengerModal(false)}
            />
        </div>
    );
}

export default MatchProfileContainer;
